define("shared/utils/errors/define-error", ["exports", "lodash", "shared/errors/ember-exex-compat"], function (_exports, _lodash, _emberExexCompat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.defineError = void 0;
  0; //eaimeta@70e063a35619d71f0,"lodash",0,"shared/errors/ember-exex-compat"eaimeta@70e063a35619d71f
  /**
   * Define a new `LaterError` class.
   * @param definition
   * @deprecated - Define static classes instead that extend from `EmberExexCompat`
   * @returns LaterError constructor
   */
  const defineError = function () {
    let definition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const BaseError = definition.extends ?? class extends _emberExexCompat.EmberExexCompat {};
    return class extends BaseError {
      constructor(params) {
        super();

        // Note: assign explicit properties provided upon creating the error class
        if (definition.code) {
          this.code = definition.code;
        }
        if (definition.message) {
          this.message = definition.message;
        }
        if (definition.name) {
          this.name = definition.name;
        }
        if (definition.resolve) {
          this.resolve = definition.resolve;
        }

        // Note: override instance-specific properties if they're provided in the constructor
        if ((0, _lodash.isString)(params) && params.length) {
          this.message = params;
        }
        if ((0, _lodash.isObject)(params)) {
          const {
            message,
            code,
            ...rest
          } = params;
          if ((0, _lodash.isString)(message) && message.length) {
            this.message = message;
          }
          if ((0, _lodash.isNumber)(code)) {
            this.code = code;
          }
          this.withAdditionalData(rest);
        }
      }
    };
  };
  _exports.defineError = defineError;
});